import React, { useState } from 'react';

function SurveyStepThirteen({ formData, onNext }) {
    const [supportRating, setSupportRating] = useState(formData.supportRating || '');
    const [supportComments, setSupportComments] = useState(formData.supportComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!supportRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ supportRating, supportComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 3: Patient Safety & Service</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How supported do you feel in raising concerns about patient care or safety? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`support-rating-${option}`}
                            name="supportRating"
                            value={option}
                            checked={supportRating === option}
                            onChange={() => setSupportRating(option)}
                        />
                        <label htmlFor={`support-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={supportComments}
                    onChange={(e) => setSupportComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!supportRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepThirteen;
